import React from 'react';
import PropTypes from 'prop-types';
import Tabs, { Tab } from 'packages/ui/NavigationTabs';

function CampaignTabs({ activeKey, campaignId }) {
  return (
    <Tabs>
      <Tab active={activeKey === 'statistics'} to={`/campaigns/${campaignId}/statistics`}>
        آمار
      </Tab>

      <Tab active={activeKey === 'info'} to={`/campaigns/${campaignId}/info`}>
        ویرایش اطلاعات
      </Tab>

      <Tab active={activeKey === 'audience'} to={`/campaigns/${campaignId}/audience`}>
        ویرایش دریافت‌کنندگان
      </Tab>

      <Tab active={activeKey === 'test'} to={`/campaigns/${campaignId}/test`}>
        تست
      </Tab>
    </Tabs>
  );
}

CampaignTabs.propTypes = {
  activeKey: PropTypes.oneOf(['statistics', 'info', 'audience', 'test']),
  campaignId: PropTypes.number.isRequired
};

export default CampaignTabs;
